import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  alertIcon: {
    textAlign: 'center'
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <h2 className="s-page-tit">{children}</h2>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContentIcon = withStyles(styles)((props) => {
  const { kind } = props;
  const { classes } = props;
  return (
    <div className={classes.alertIcon}><img src={"/assets/images/dialog/ic-"+kind+".svg"} alt={kind}/></div>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '14px 40px',
    minHeight: 80,
    fontSize: 16,
    fontWeight: 'normal',
    textAlign: 'center'
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '0px 40px 40px 40px',
  },
}))(MuiDialogActions);

export default function Confirm(props) {
  
  const handleConfirm = (e) => {
    props.handleFormSubmit(e);
    props.handleClose();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
      <Dialog fullWidth={true} onClose={handleClose} aria-labelledby="customized-dialog-title" open={true}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          { props.title }
        </DialogTitle>
        <DialogContentIcon kind={props.kind}/>
        <DialogContent>
          { props.message &&
            props.message.split('\n').map( (line, i) => {return (<div key={i}>{line}</div>);})
          }
        </DialogContent>
        <DialogActions>
          <button className="button popup-ok-button" onClick={handleConfirm}>네</button>
          <button className="button popup-ok-button white-button" onClick={handleClose}>아니오</button>
        </DialogActions>
      </Dialog>
  );
}